import axios from "axios";
import { API } from '@/env'
import Vuex from '@/store'

export default {
    /**
     * Get user profile data
     * @api {POST} api/web/getProfile
     * @returns {Promise} represents logged in user data
     */
    getProfile() {
        const options = {
            method: 'POST',
            url: API + 'api/web/getProfile',
            headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Update user profile
     * @api {POST} api/web/updateProfile
     * @param {object} data
     */
    updateProfile(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/updateProfile',
            headers: { 'content-type': 'multipart/form-data', Authorization: 'Bearer ' + Vuex.getters.token },
            data: data
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    /**
     * Update Password (Change password)
     * @api {POST} api/web/updateProfile
     * @param {object} data
     */
    updatePassword(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/passwordUpdate',
            headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
            data: data,
        };
        return new Promise((resolve, rejecte) => {
            axios(options).then(response => {
                resolve(response);
            }).catch(error => {
                rejecte(error);
            });
        });
    },

    /**
     * Get subadmins
     * @api {GET} api/web/subadmins
     * @returns {Promise} represents logged in user data
     */
    getSubAdmins() {
        const options = {
            method: 'GET',
            url: API + 'api/web/subadmins',
            headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Get schools
     * @api {GET} api/web/schools
     * @returns {Promise} represents logged in user data
     */
    getSchools() {
        const options = {
            method: 'GET',
            url: API + 'api/web/schools',
            headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Get user youtube url
     * @api {GET} api/web/youtube-url
     * @returns {Promise} represents logged in user data
     */
     getYoutubeVideo() {
        const options = {
            method: 'GET',
            url: API + 'api/web/youtube-url',
            headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Submit youtube url
     * @api {POST} api/web/youtube-url
     * @returns {Promise} represents logged in user data
     */
     updateYoutubeURL(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/youtube-url',
            headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Apply Coupon,
     * @param,
     * @api {POST}
     * @param data
     */
    apply_promocode(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/apply-promo',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },
}
